import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './theme.css';
import { App } from './App.js';
import { registerServiceWorker } from './register-sw.js';

createRoot(document.getElementById('root')!).render(
  <StrictMode><App /></StrictMode>,
);

registerServiceWorker();
